import { render, staticRenderFns } from "./MediaServer.vue?vue&type=template&id=b5736ea0"
import script from "./MediaServer.vue?vue&type=script&lang=ts"
export * from "./MediaServer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports